import axios from 'axios';


var apiUrl = "https://dev.drishtiair.com/api/v1/"
var apiKey = "gAk2Lcqf11NWeWRsZl1rx2ZikZSZt9"


export const HTTP = axios.create({
  baseURL: apiUrl,
  headers: {
    'API-KEY': apiKey
  }
})



// WEBPACK FOOTER //
// ./src/http-common.js